import { Avatar, AvatarGroup, Stack } from '@mui/material'
import React, { useContext } from 'react'
import { AiOutlineOrderedList } from 'react-icons/ai'
import { useNavigate } from 'react-router-dom'
import { Context } from '../../utils/context'
import OrderDetail from './OrderDetail'

const SingleOrderItem = ({ data }) => {
    const { setOrderDetailItem } = useContext(Context)

    const getDiscount = (price, originalPrice) => {
        const value = parseInt((price * 100) / originalPrice);
        return Math.abs(Math.abs(value - 100));
    };
    const navigate = useNavigate();
    return (
        <Stack onClick={() => {
            navigate(`/orders/${data?.ordersData?._id}`)
            setOrderDetailItem(data?._id)
        }} className='rounded' direction={"row"} border={"1px solid #ddd"} padding="14px" gap="14px" my="5px">
            <Stack sx={{ width: "15%" }}>
                <img className="rounded object-fit-cover" style={{ maxHeight: "150px" }} alt={data?.images?.featuredImage?.alt} src={data?.images?.featuredImage?.src} />
            </Stack>
            <Stack sx={{ display: "flex", flexDirection: "column", gap: "5px", width: "40%" }}>
                <p style={{ fontWeight: 600, fontSize: "14px" }}>{data?.name}</p>
                {!!(data?.productType == "WithBoth") || (data?.productType == "WithColor") ?
                    <Stack direction="row" gap="8px" justifyContent={"flex-start"} alignItems="center">
                        <p style={{ fontWeight: 600, fontSize: "14px" }}>Color</p>
                        <div
                            style={{ backgroundColor: `${data?.color}` }}
                            className={`h-4 w-4 rounded-full shadow-black `}
                        ></div>
                    </Stack>
                    :
                    ""
                }
                {!!(data?.productType == "WithBoth") || (data?.productType == "WithSize") ?
                    <Stack direction="row" gap="8px">
                        <p style={{ fontWeight: 600, fontSize: "14px" }}>Size : </p>
                        <p style={{ fontWeight: 600, fontSize: "14px" }}>{data?.size}</p>
                    </Stack>
                    :
                    ""
                }
                <p style={{ fontWeight: 600, fontSize: "14px" }}>Quantity : {data?.quantity}</p>
            </Stack>
            <Stack sx={{ width: "20%" }}>
                <p style={{ fontWeight: 600, fontSize: "14px" }}>₹ {data?.originalPrice}</p>
                <p style={{ fontWeight: 600, fontSize: "14px", textDecoration: "line-through" }}>₹ {data?.price} <span style={{ color: "green", textDecoration: "" }}>&nbsp; % {getDiscount(data?.price, data?.originalPrice)}</span></p>
                <p style={{ fontWeight: 600, fontSize: "14px" }}>{data?.ordersData?.payment_mode}</p>
            </Stack>
            <Stack sx={{ width: "35%" }}>
                <p style={{ fontWeight: 600, fontSize: "14px", color: "grey" }}>Order ID : {data?.ordersData?._id}</p>
                <p style={{ fontWeight: 600, fontSize: "14px" }}>Ordered On {new Date(data?.ordersData?.createdAt).toLocaleDateString()}</p>
                <p style={{ fontWeight: 600, fontSize: "14px", color: "blue" }}> {data?.ordersData?.delivery_status}</p>
            </Stack>
        </Stack >
    )
}

export default SingleOrderItem